<style scoped>
.flex-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.retry {
  cursor: pointer;
}

.retry:hover {
  color: #007bff;
}
</style>

<template>
  <b-row class="m-12">
    <b-col class="flex-container" v-if="loading">
      <circle9 class="spinning-icon"></circle9>
      <p>Please wait...</p>
    </b-col>
    <message :message="errorMessage" :iconClass="iconClass" :icon="icon" v-else-if="error">
      <font-awesome-icon icon="sync" class="retry" title="Try again" @click="request"/>
    </message>
    <b-col v-else>
      <slot></slot>
    </b-col>
  </b-row>
</template>

<script>
import { Circle9 } from 'vue-loading-spinner';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle, faSync } from '@fortawesome/free-solid-svg-icons';
import Message from '@/components/utils/Message';


library.add([faExclamationTriangle, faSync]);

export default {
  name: 'LoadingComponent',
  components: {
    Circle9,
    Message,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    autoRequest: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: 'Unable to load data',
    },
    iconClass: {
      type: String,
      default: 'text-light-danger',
    },
    icon: {
      type: String,
      default: 'exclamation-triangle',
    },
  },
  mounted() {
    if (this.autoRequest) {
      this.request();
    }
  },
  data() {
    return {
      loading: false,
      response: {},
      error: null,
    };
  },
  methods: {
    request() {
      this.loading = true;
      this.error = null;
      this.$reqs.get(this.url, null, { pre: false, post: false, error: false }).then((response) => {
        this.loading = false;
        if (response.status === 200) {
          this.$emit('success', response.data);
        }
      }).catch((error) => {
        if (error.response.status >= 500) {
          this.error = error;
        }
        this.$emit('error', error.response);
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/LoadingComponent.vue